/**
 * Strip auth-bearing query params from the URL on first load. These come
 * in from the IGNODE Portal's hand-off via the Go proxy, which consumes
 * them server-side to set an encrypted cookie — the SPA never reads them.
 * Leaving them in the URL leaks the JWT into browser history, the Referer
 * header, and any downstream link the user clicks.
 *
 * Port of agent-builder's `scrubAuthFromUrl` from App.jsx.
 */
export function scrubAuthFromUrl(): void {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    let dirty = false;
    for (const k of ['token', 'r', 'refresh_token', 'access_token']) {
        if (params.has(k)) {
            params.delete(k);
            dirty = true;
        }
    }
    if (!dirty) return;
    const qs = params.toString();
    const newUrl =
        window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
}
